import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames, useUitkContext } from 'uitk-react-utils';
import styles from './uitk-text.css';
import { UitkHeadingTags, UitkTypeAlignments, UitkHeadingSizes, UitkTypeOverflows, UitkTypeHyphens } from './types.esm.js';
var getClassNameList = classNames.bind(styles);
/**
 * Use for title/headings of pages, sections, articles, listings, rate plans, etc.
 * Ensure that you are choosing the correct semantic `tag` for your heading.
 */
var UitkHeading = function (props) {
  var align = props.align,
    children = props.children,
    className = props.className,
    tag = props.tag,
    size = props.size,
    overflow = props.overflow,
    hyphens = props.hyphens,
    domRef = props.domRef,
    attributes = __rest(props, ["align", "children", "className", "tag", "size", "overflow", "hyphens", "domRef"]);
  var Tag = tag && UitkHeadingTags.get(tag) || UitkHeadingTags.get('h3');
  var _a = useUitkContext(),
    contextData = _a.data,
    context = _a.context;
  var _b = contextData !== null && contextData !== void 0 ? contextData : {},
    bottomScrimContext = _b.bottomScrimContext,
    overlayScrimContext = _b.overlayScrimContext,
    contextClassNames = _b.contextClassNames;
  var wrapperClassNames = getClassNameList('uitk-heading', align && UitkTypeAlignments.get(align), !bottomScrimContext && (size && UitkHeadingSizes.get(size) || UitkHeadingSizes.get(6)), overflow && UitkTypeOverflows.get(overflow), hyphens && UitkTypeHyphens.get(hyphens), bottomScrimContext && "in-bottom-scrim", overlayScrimContext && "in-overlay-scrim", context === 'uitk-dialog-context' && 'in-dialog', contextClassNames === null || contextClassNames === void 0 ? void 0 : contextClassNames.UitkHeading, className);
  return children ? React.createElement(Tag, __assign({
    className: wrapperClassNames,
    ref: domRef
  }, attributes), children) : null;
};
UitkHeading.displayName = 'UitkHeading';
export { UitkHeading };